module.exports = __webpack_public_path__ + "media/cuu/sec_educacion-2618bfe3.jpg";